import { container } from '@eureka/services'
import type { ICoreDataWrapper } from '@eureka/services/src/exception'
import { SeekSubmitInput } from '../../types';
import { SeekSubmitOutput } from '../../types';


export function seekSubmit(inputData: SeekSubmitInput) {
    return container.RnDHttp.post<ICoreDataWrapper<SeekSubmitOutput>>({
        url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/seek/submit`,
        data: inputData,
    }).then((res) => {
        return res.data as SeekSubmitOutput;
    });
}